import { SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = {
  display: 'flex',
  gap: '16px',
  alignItems: 'center'
};

const launchButton: SxProps<Theme> = {
  minWidth: '220px'
};

const initiateLaunchButton: SxProps<Theme> = {
  minWidth: '180px',
  padding: '12px 32px'
};

const draftButton: SxProps<Theme> = {
  minWidth: '140px',
  borderColor: 'primary.main',
  color: 'primary.main'
};

const savedText: SxProps<Theme> = {
  fontSize: '14px',
  color: 'customGrey.dark'
};

export const launchButtonsSx = {
  container,
  launchButton,
  initiateLaunchButton,
  draftButton,
  savedText
};
